import { CALL_API, Schemas } from '../../common/middleware/api';

export const MOVE_LESSONS_SEARCH_CHILDREN_REQUEST = 'MOVE_LESSONS_SEARCH_CHILDREN_REQUEST';
export const MOVE_LESSONS_SEARCH_CHILDREN_SUCCESS = 'MOVE_LESSONS_SEARCH_CHILDREN_SUCCESS';
export const MOVE_LESSONS_SEARCH_CHILDREN_FAILURE = 'MOVE_LESSONS_SEARCH_CHILDREN_FAILURE';

export const MOVE_LESSONS_REQUEST = 'MOVE_LESSONS_REQUEST';
export const MOVE_LESSONS_SUCCESS = 'MOVE_LESSONS_SUCCESS';
export const MOVE_LESSONS_FAILURE = 'MOVE_LESSONS_FAILURE';

export const MOVE_LESSONS_CHILD_LESSONS_REQUEST = 'MOVE_LESSONS_CHILD_LESSONS_REQUEST';
export const MOVE_LESSONS_CHILD_LESSONS_SUCCESS = 'MOVE_LESSONS_CHILD_LESSONS_SUCCESS';
export const MOVE_LESSONS_CHILD_LESSONS_FAILURE = 'MOVE_LESSONS_CHILD_LESSONS_FAILURE';

export const MOVE_LESSONS_WEEKLY_PROGRAMS_REQUEST = 'MOVE_LESSONS_WEEKLY_PROGRAMS_REQUEST';
export const MOVE_LESSONS_WEEKLY_PROGRAMS_SUCCESS = 'MOVE_LESSONS_WEEKLY_PROGRAMS_SUCCESS';
export const MOVE_LESSONS_WEEKLY_PROGRAMS_FAILURE = 'MOVE_LESSONS_WEEKLY_PROGRAMS_FAILURE';

export const searchChildren = (options) => ({
	[CALL_API]: {
		types: [MOVE_LESSONS_SEARCH_CHILDREN_REQUEST, MOVE_LESSONS_SEARCH_CHILDREN_SUCCESS, MOVE_LESSONS_SEARCH_CHILDREN_FAILURE],
		endpoint: 'api/children/search',
		request: options,
		schema: Schemas.CHILD_ARRAY
	}
});

export const moveLessons = (options, onSuccessEvent) => ({
	[CALL_API]: {
		types: [MOVE_LESSONS_REQUEST, MOVE_LESSONS_SUCCESS, MOVE_LESSONS_FAILURE],
		endpoint: 'api/childLessons/move',
		method: 'POST',
		request: options,
		form: 'moveLessonsForm',
		onSuccessEvent
	}
});

export const loadChildLessons = (options) => ({
	[CALL_API]: {
		types: [MOVE_LESSONS_CHILD_LESSONS_REQUEST, MOVE_LESSONS_CHILD_LESSONS_SUCCESS, MOVE_LESSONS_CHILD_LESSONS_FAILURE],
		endpoint: 'api/childLessons/unpaged',
		request: options,
		schema: Schemas.CHILD_LESSONS_ARRAY
	}
});

export const loadWeeklyProgram = (options) => ({
	[CALL_API]: {
		types: [MOVE_LESSONS_WEEKLY_PROGRAMS_REQUEST, MOVE_LESSONS_WEEKLY_PROGRAMS_SUCCESS, MOVE_LESSONS_WEEKLY_PROGRAMS_FAILURE],
		endpoint: 'api/weeklyPrograms/unpaged',
		request: options,
		schema: Schemas.WEEKLY_PROGRAM_ARRAY
	}
});

